export default __webpack_public_path__ + "static/media/marker_blue.751701da.svg";